// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--spacing-double);
}
@media (max-width: 1024px) {
  .tour {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .tour {
    grid-template-columns: 1fr;
  }
}
.tour__information .image {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
  background: var(--ion-background-secondary-color);
  border-radius: var(--spacing-quarter);
  margin-top: var(--spacing-half);
}
.tour__information .price {
  text-align: right;
  font-weight: bold;
}
.tour__departure .ticket-options {
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 3fr 1fr;
  align-items: center;
  gap: var(--spacing-half);
}
.tour__departure .ticket-options__stock {
  text-align: right;
}
.tour__departure .ticket-options__actions {
  text-align: right;
}
.tour__participants .pack-list ion-label {
  font-weight: normal;
  text-transform: none;
}
.tour__actions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing);
  margin-top: var(--spacing-double);
  padding: var(--spacing);
  background: var(--ion-background-secondary-color);
}
.tour .alert {
  display: flex;
  align-items: center;
  gap: var(--spacing-quarter);
  padding: var(--spacing-quarter);
  margin-top: var(--spacing-half);
  border-radius: var(--spacing-quarter);
  position: relative;
  width: 100%;
}
.tour .alert span {
  font-size: var(--font-size-nano);
}
.tour .alert__warning {
  background: var(--ion-color-warning);
  color: var(--ion-color-warning-contrast);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tour-consultant/booking/booking.page.scss"],"names":[],"mappings":"AAIA;EACI,aAAA;EACA,kCAAA;EACA,0BAAA;AAHJ;AAKI;EALJ;IAMQ,8BAAA;EAFN;AACF;AAII;EATJ;IAUQ,0BAAA;EADN;AACF;AAMQ;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iDAAA;EACA,qCAAA;EACA,+BAAA;AAJZ;AAOQ;EACI,iBAAA;EACA,iBAAA;AALZ;AAWQ;EACI,WAAA;EACA,aAAA;EACA,kCAAA;EACA,mBAAA;EACA,wBAAA;AATZ;AAWY;EACI,iBAAA;AAThB;AAYY;EACI,iBAAA;AAVhB;AAiBQ;EACI,mBAAA;EACA,oBAAA;AAfZ;AAoBI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;AAlBR;AAsBI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,+BAAA;EACA,+BAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;AApBR;AAsBQ;EACI,gCAAA;AApBZ;AAuBQ;EACI,oCAAA;EACA,wCAAA;AArBZ","sourcesContent":["\n\n\n\n.tour{\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: var(--spacing-double);\n    \n    @media (max-width: 1024px) {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n\n\n    &__information {\n\n        .image {\n            width: 100%;\n            object-fit: cover;\n            aspect-ratio: 16/9;\n            background: var(--ion-background-secondary-color);\n            border-radius: var(--spacing-quarter);\n            margin-top: var(--spacing-half);\n        }\n\n        .price {\n            text-align: right;\n            font-weight: bold;\n        }\n    }\n\n    &__departure {\n        \n        .ticket-options {\n            width: 100%;\n            display: grid;\n            grid-template-columns: 3fr 3fr 1fr;\n            align-items: center;\n            gap: var(--spacing-half);\n\n            &__stock {\n                text-align: right;\n            }\n            \n            &__actions {\n                text-align: right;\n            }\n        }\n    }\n\n    &__participants {\n\n        .pack-list ion-label {\n            font-weight: normal;\n            text-transform: none;\n        }\n        \n    }\n\n    &__actions {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: var(--spacing);\n        margin-top: var(--spacing-double);\n        padding: var(--spacing);\n        background: var(--ion-background-secondary-color);\n    }\n\n\n    .alert {\n        display: flex;\n        align-items: center;\n        gap: var(--spacing-quarter);\n        padding: var(--spacing-quarter);\n        margin-top: var(--spacing-half);\n        border-radius: var(--spacing-quarter);\n        position: relative;\n        width: 100%;\n\n        span {\n            font-size: var(--font-size-nano);\n        }\n\n        &__warning {\n            background: var(--ion-color-warning);\n            color: var(--ion-color-warning-contrast);\n        }\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
